import React, {Component} from 'react'
import {Row, Col, Container} from "reactstrap";
import { connect } from 'react-redux'
import ModifierDialogue from '../modifier/ModifierDialogue'
import OpenItem from '../misc/OpenItem'

var modifierDialogueUtil = require('../modifier/modifierDialogueUtil');
var stringUtil = require('../../../../utils/string/stringUtil.js');
var saleInitializer = require('../../../../utils/domain/sales/saleInitializer');
var formatter = require('../../../../utils/formatter/formatter.js');
var saleCommonUtility = require('../../../../utils/domain/sales/saleCommonUtility.js');
var saleContextUtil = require('../../utils/saleContextUtil.js');

class Items extends Component 
{
    constructor(props)
    {
        super(props);
        this.renderModifierDialogue = this.renderModifierDialogue.bind(this);
        this.renderOpenItemDialogue = this.renderOpenItemDialogue.bind(this);

        this.state = {};
    }

    componentDidMount() 
    {
        this.scrollToBottom();
    }
    
    componentDidUpdate() 
    {
        this.scrollToBottom();
    }

    scrollToBottom = () => 
    {
        if (this.messagesEnd != null)
            this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }

    render()
    {
        let sale = this.props.saleContext.sale;

        if (sale == null || sale.saleItems == null || sale.saleItems.length <= 0)
            return;

        var components = [];

        sale.saleItems.forEach (saleItem =>
        {
            let background = null;
            let onClick = null;
            let saleContext = this.props.saleContext;
            
            if (this.props.saleContext.selectedItems.find(i => i == saleItem) != null)
            {
                background = "#E5F9FF";
                onClick = (event)=>
                {
                    event.stopPropagation();
                    saleContext.selectedItems = this.props.saleContext.selectedItems.filter(i => i != saleItem);
                    saleContextUtil.raiseSaleContextSaleChangeEvent(false, false, false);
                }
            }
            else
            {
                onClick = (event)=>
                {
                    event.stopPropagation();
                    saleContext.selectedItems.push(saleItem);
                    saleContextUtil.raiseSaleContextSaleChangeEvent(false, false, false);
                }
            }

            let subComponents = [];
            this.renderSaleItem(saleItem, subComponents, saleItem, 0);
            components.push(<div style={{width:'100%', 
                                         paddingTop:'10px', paddingBottom:'10px', 
                                         paddingLeft:'5px', paddingRight:'5px', 
                                         borderBottom:'1px solid black',
                                         background:background}}
                                 onClick={onClick}
                                 onDoubleClick={(event)=>
                                 {
                                    event.stopPropagation();
                                    this.onSaleItemDoubleClick(saleItem);
                                 }}>
                                {subComponents}
                            </div>)
        });

        components.push(<div style={{ float:"left", clear: "both" }}
                             ref={(el) => { this.messagesEnd = el; }}>
                        </div>)

        return (<div className='h-100 w-100 d-flex flex-column justify-content-start align-items-start'>
                    {components}
                    {this.renderModifierDialogue()}
                    {this.renderOpenItemDialogue()}
                </div>)
    }

    renderSaleItem(saleItem, components, rootItem, marginLeft)
    {
        let sale = this.props.saleContext.sale;

        var formattedPrice = "";

        if (!stringUtil.isStringNullOrEmpty(saleItem.unitPrice) && saleItem.unitPrice > 0)
            formattedPrice = formatter.convertToCurrencyFormat(saleItem.unitPrice * saleItem.quantity);

        var backgroundColor = null;
        var foregroundColor = null;
        if (saleItem !== rootItem && !stringUtil.isStringNullOrEmpty(saleItem.backgroundColor))
            backgroundColor = saleItem.backgroundColor;
        if (saleItem !== rootItem && !stringUtil.isStringNullOrEmpty(saleItem.foregroundColor))
            foregroundColor = saleItem.foregroundColor;

        var textDecoration = null;
        if (saleItem.isRefunded)
            textDecoration= 'line-through';

        var caption = saleCommonUtility.formatSaleItemCaption(saleItem);
        
        if (!stringUtil.isStringNullOrEmpty(saleItem.instructions))
            caption = `${caption} ♨`

        if (saleItem.isComplimented && saleItem == rootItem)
            caption = `${caption} (✺ Complimentary ✺)`;
        else
        {
            var itemDiscount = saleCommonUtility.retrieveItemDiscount(sale, saleItem);
            if (itemDiscount != null)
            {
                caption = `${caption} (✺ Disc - ${formatter.convertToCurrencyFormat(itemDiscount.amount)} ✺)`;
            }

            if (saleItem.isPaid)
                caption = "✅" + ` ${caption}`;
        }
        

        components.push(<Row>
                            <Col md={1}>
                                <div className='w-100'>
                                    {saleItem == rootItem ? saleItem.quantity : ''}
                                </div>
                            </Col>
                            <Col md={8}>  
                                <span className='w-100' style={{marginLeft:marginLeft, background:backgroundColor, color:foregroundColor, textDecoration:textDecoration}}>
                                    {caption}
                                </span> 
                            </Col>
                            <Col md={3}>
                                <div className='w-100' style={{textAlign:'end', textDecoration:textDecoration}}>
                                    {formattedPrice}
                                </div>
                            </Col>
                        </Row>);

        saleItem.saleItems.forEach(subItem =>
            {
                this.renderSaleItem(subItem, components, rootItem, marginLeft+20);
            })
    }

    onSaleItemDoubleClick(saleItem)
    {
        let menuContextPayload = saleContextUtil.getSaleItemMenuContextPayload(saleItem);
        if (menuContextPayload == null)
            return;

        if (!menuContextPayload.isOpenItem)
        {
            this.state.modifierDialogueContext = {};
            this.state.modifierDialogueContext.saleItem = saleItem;
            this.setState({});
        }
        else
        {
            this.state.openItemMenuContext = {};
            this.state.openItemMenuContext.saleItem = saleItem;
            this.setState({});
        }
    }

    renderModifierDialogue()
    {
        if (this.state.modifierDialogueContext == null)
            return;

        var modifiersViewModels = modifierDialogueUtil.buildModifiersViewModels(this.state.modifierDialogueContext.saleItem);
        if (modifiersViewModels.length <= 0)
        {
            this.state.modifierDialogueContext = null;
            return;
        }

        return <ModifierDialogue 
                saleItem = {this.state.modifierDialogueContext.saleItem}
                startingModifierIndex = {0}
                modifiersViewModels={modifiersViewModels}
                isNewOrderFlow={false}
                sale={this.props.saleContext.sale}
                menu={this.props.saleContext.primaryMenu}
                onCancel={()=>
                {
                    this.state.modifierDialogueContext = null;
                    this.setState({});
                }}
                onSave = {(modifiersViewModels)=>
                {
                    var saleItem = this.state.modifierDialogueContext.saleItem;
                    
                    this.state.modifierDialogueContext = null;
                    this.setState({});
                    
                    modifierDialogueUtil.updateSaleItemWithModifiersViewModels(this.props.saleContext.sale, saleItem, modifiersViewModels);
                    saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                }}
            />
    }

    renderOpenItemDialogue()
    {
        if (this.state.openItemMenuContext == null)
            return null;

        let saleItem = this.state.openItemMenuContext.saleItem;
        let openItem = JSON.parse(JSON.stringify(saleContextUtil.getSaleItemMenuContext(saleItem)));
        openItem.quantity = saleItem.quantity;
        openItem.instructions = saleItem.instructions;

        return <OpenItem 
                    values={openItem}
                    onCancel={()=>
                    {
                        this.state.openItemMenuContext = null;
                        this.setState({});                
                    }}
                    handleSubmit={(openItem)=>
                    {

                        this.state.openItemMenuContext = null;
                        this.setState({});  
                        
                        let vat = saleInitializer.calculateUnitTax(openItem.unitPrice * 1, (openItem.vat * 1) / 100);
                        saleItem.quantity = openItem.quantity * 1;
                        saleItem.instructions = openItem.instructions;
                        saleItem.caption = openItem.caption;
                        saleItem.unitPrice = openItem.unitPrice * 1;
                        saleItem.vat = vat;

                        saleContextUtil.setSaleItemMenuContext(saleItem, openItem, true);
                        saleContextUtil.raiseSaleContextSaleChangeEvent(true);
                        
                    }}/>
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(Items)